import styled, { css, keyframes } from 'styled-components';
// animations.
// -----------------------------------------------------------------------------
const fadeIn = keyframes `
  from { bottom: 0; opacity: 0; }
  to   { bottom: 30px; opacity: 1; }
`;
// styled-components.
// -----------------------------------------------------------------------------
export const ToastItemRoot = styled.div `
  ${({ maxWidth }) => css `
    // Animations.
    animation-name: ${fadeIn};
    animation-duration: 0.5s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;

    // Block.
    width: fit-content;
    ${maxWidth && `max-width: ${maxWidth};`}
  `}
`;
//# sourceMappingURL=ToastItem.styled.js.map